import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { DataTablesResponse } from '../models/datatables';
import { environment } from '../../environments/environment';
import { LeapmotorMktCoopActionChangeAnimationDTO, LeapmotorMktCoopActionDTO, LeapmotorMktCoopActionPostDTO, MktCoopActionFilters, MktCoopBudgetResult } from '../models/mkt-coop-action';



@Injectable({
    providedIn: 'root'
})

export class MktCoopActionService {

    private pathAPI = environment.urlAPI;
    private controller = "LeapmotorMktCoopAction/";

    constructor(private http: HttpClient) { }

    //#region CRUD

    public Get(id: string): Observable<LeapmotorMktCoopActionDTO> {
        return this.http.get<LeapmotorMktCoopActionDTO>(this.pathAPI + this.controller + id);
    }

    public Put(id: string, data: FormData): Observable<any> {
        return this.http.put<any>(this.pathAPI + this.controller + id, data);
    }

    public EditApprovedAction(id: string, data: FormData): Observable<any> {
        return this.http.put<any>(this.pathAPI + this.controller + 'EditApprovedAction/' + id, data);
    }

    public Post(data: FormData): Observable<any> {
        return this.http.post<any>(this.pathAPI + this.controller, data);
    }


    public ChangeStatus(id: string, data: FormData): Observable<any> {
        return this.http.put<any>(this.pathAPI + this.controller + 'ChangeStatus/' + id, data);
    }

    public ChangeAnimation(id: string, data: LeapmotorMktCoopActionChangeAnimationDTO): Observable<any> {
        return this.http.put<any>(this.pathAPI + this.controller + 'ChangeAnimation/' + id, data);
    }

    //#endregion


    public CalculateSubvention(data: FormData, idAction: string = null): Observable<any> {

        if (idAction == null)
            return this.http.post<any>(this.pathAPI + this.controller + 'CalculateSubvention', data);
        else
            return this.http.post<any>(this.pathAPI + this.controller + 'CalculateSubvention?idAction=' + idAction, data);
    }


    public GetDatatable(data: any, filter: string): Observable<DataTablesResponse> {
        return this.http.post<DataTablesResponse>(this.pathAPI + this.controller + 'GetDatatable/' + filter, data);
    }


    //#region SELECT-LISTS


    public GetDistributorsDashboard(): Observable<any> {
        return this.http.get<any>(this.pathAPI + this.controller + 'GetDistributorsDashboard/');
    }

    public GetTypesDashboard(): Observable<any> {
        return this.http.get<any>(this.pathAPI + this.controller + 'GetTypesDashboard/');
    }

    public GetMediasDashboard(idType: number): Observable<any> {
        return this.http.get<any>(this.pathAPI + this.controller + 'GetMediasDashboard/' + idType);
    }

    public GetStatusDashboard(): Observable<any> {
        return this.http.get<any>(this.pathAPI + this.controller + 'GetStatusDashboard/');
    }

    public GetMonthsDashboard(): Observable<any> {
        return this.http.get<any>(this.pathAPI + this.controller + 'GetMonthsDashboard/');
    }

    public GetYearsDashboard(): Observable<any> {
        return this.http.get<any>(this.pathAPI + this.controller + 'GetYearsDashboard/');
    }

    public GetTypes(): Observable<any> {
        return this.http.get<any>(this.pathAPI + this.controller + 'GetTypes/');
    }

    public GetMedias(idType: number): Observable<any> {
        return this.http.get<any>(this.pathAPI + this.controller + 'GetMedias/' + idType);
    }

    //#endregion

    //#region BUDGET



    public GetBudgetData(filter: MktCoopActionFilters): Observable<MktCoopBudgetResult[]> {
        return this.http.post<MktCoopBudgetResult[]>(this.pathAPI + this.controller + 'GetBudgetData/', filter);
    }

    //#endregion

    DownloadExcelAction(idAnimation: number): Observable<Blob> {
        let requestOptions: Object = {
            responseType: 'blob'
        }
        let endpoint = this.pathAPI + this.controller + 'GetAnimationActionExcel/' + idAnimation;
        return this.http.post<Blob>(endpoint, null, requestOptions);
    }

}
